<!--form id="form-checkout" [formGroup]="paymentMercadoPagoForm" (ngSubmit)="submitPayment()">
  <div id="cardNumber"></div>
  <div id="expirationDate"></div>
  <div id="securityCode"></div>
  <div id="cardholderName"></div>
  <div id="issuer"></div>
  <div id="installments"></div>
  <div id="identificationType"></div>
  <div id="identificationNumber"></div>
  <div id="cardholderEmail"></div>
  <button type="submit">Pagar</button>
</form-->
<div class="payment-form">
    <app-loader *ngIf="loading" style="height: 100%;"></app-loader>
    <form id="form-checkout">
        <label class="payment-form-label">Titular de la tarjeta*</label>
        <input id="form-checkout__cardholderName" type="text" class="payment-form-input" />
        <br>
        <label class="payment-form-label">Numero de tarjeta*</label>
        <div id="form-checkout__cardNumber" class="container"></div>

        <label class="payment-form-label">Fecha de expiración*</label>
        <div id="form-checkout__expirationDate" class="container"></div>

        <label class="payment-form-label">CVV*</label>
        <div id="form-checkout__securityCode" class="container"></div>
        <label class="payment-form-label">Banco*</label>
        <select id="form-checkout__issuer" class="payment-form-select"></select>
        <br>
        <label class="payment-form-label">Coutas*</label>
        <select id="form-checkout__installments" class="payment-form-select"></select>
        <br>
        <label class="payment-form-label">E-mail*</label>
        <input type="email" id="form-checkout__cardholderEmail" class="payment-form-input" />
        <button type="submit" id="form-checkout__submit">
            <mat-icon [appLoadingButton]="loading" color="white">refresh</mat-icon>
            Pagar
        </button>
        <progress hideToggle *ngIf="loading" value="0" class="progress-bar">Cargando...</progress>
    </form>
</div>

<!--div class="payment-form">
    <form id="form-checkout">
        <mat-form-field>
            <mat-label>Nombre del titular</mat-label>
            <input matInput type="text" formControlName="cardholderName">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Correo</mat-label>
            <input matInput type="text" formControlName="cardholderEmail">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Numbero de la tarjeta</mat-label>
            <input matInput type="text" formControlName="cardNumber">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Numero de expiracion</mat-label>
            <input matInput type="text" formControlName="expirationDate">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Numero de seguridad</mat-label>
            <input matInput type="text" formControlName="securityCode">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Banco emisor</mat-label>
            <mat-select formControlName="issuer">
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Cuotas</mat-label>
            <mat-select formControlName="installments">
            </mat-select>
        </mat-form-field>
        <button mat-flat-button  type="submit" id="form-checkout__submit">

        </button>
    </form>
</div-->